import { FaBus } from "react-icons/fa";
import { defineType } from "sanity";

export default defineType({
  name: "landProgramme",
  title: "Land Programme",
  type: "document",
  icon: FaBus,
  preview: {
    select: {
      name: "name",
      code: "code"
    },
    prepare(value) {
      return {
        title: value.name,
        subtitle: value.code
      };
    }
  },
  fields: [
    {
      name: "port",
      type: "reference",
      weak: true,
      to: [{ type: "port" }],
      readOnly: true
    },
    {
      name: "landProgrammeId",
      title: "Land Programme ID",
      description: "Res land_id, absent for iTravel land programmes",
      type: "number",
      readOnly: true
    },
    {
      name: "landProgrammeWebCode",
      title: "Land Programme Web Code",
      description: "Unique across Res and iTravel land programmes",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "name",
      title: "Name",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "code",
      title: "Code",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "duration",
      title: "Duration",
      type: "number",
      readOnly: true
    },
    {
      name: "image",
      title: "Image",
      description: "Image used in the popup (where available)",
      type: "image",
      options: {
        hotspot: true
      },
      readOnly: true
    },
    {
      name: "descriptionHtml",
      title: "Description (Raw HTML)",
      description: "HTML used in the popup",
      type: "text",
      readOnly: true
    }
  ]
});
